export const isInvalidMail = (email) => {
  return (email && email.slice(0, 11).replace(/\D/g, '').length === 11);
}
